export var precisionRound = function precisionRound(num) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var factor = Math.pow(10, precision);
  return Math.round(num * factor) / factor;
};